var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h5", [
      _vm._v(
        _vm._s(!_vm.localUser.id ? "Создание нового" : "Редактирование") +
          " владельца"
      ),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "" } }, [_vm._v("Фамилия и инициалы")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localUser.short_name,
              expression: "localUser.short_name",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.localUser.short_name },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.localUser, "short_name", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "" } }, [_vm._v("Полное ФИО")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localUser.full_name,
              expression: "localUser.full_name",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.localUser.full_name },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.localUser, "full_name", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "" } }, [_vm._v("Догин к банкингу")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localUser.banking_login,
              expression: "localUser.banking_login",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.localUser.banking_login },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.localUser, "banking_login", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "" } }, [_vm._v("Пароль к банкингу")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localUser.banking_password,
              expression: "localUser.banking_password",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.localUser.banking_password },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.localUser, "banking_password", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "" } }, [_vm._v("Комментарий")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localUser.options.comment,
              expression: "localUser.options.comment",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.localUser.options.comment },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.localUser.options, "comment", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localUser.is_active,
                expression: "localUser.is_active",
              },
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.localUser.is_active)
                ? _vm._i(_vm.localUser.is_active, null) > -1
                : _vm.localUser.is_active,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.localUser.is_active,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.localUser, "is_active", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.localUser,
                        "is_active",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.localUser, "is_active", $$c)
                }
              },
            },
          }),
          _vm._v(" запись владельца активна"),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-1 text-right" },
        [
          _c("LoadingButton", {
            attrs: {
              title: "Сохранить",
              loading: _vm.loading,
              color: "white",
              onClick: () => _vm.saveRecord(),
              className: "btn btn-success",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }